// extracted by mini-css-extract-plugin
export default {"option-wrapper":"T3x7nfoQFTfsE02AobWSwQ==","delivery-channel-switch":"WPLt9oeX5lb1c98ODfvvrg=="};